import { Box } from '@chakra-ui/react'
import { FC, useMemo } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'
import useAuth from '@hook/shared/use-auth'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import LayoutEmpty from '@component/Layout/Empty'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'
import SelectedTableBarReabCronPurchaseFerias from '@component/Parameterization/cronPurchase/SelectedTableBarFerias'

import cronPurchaseFerias from '@base/variables/headers/cronograma-purchase/cron-purchase-ferias'

const PurchaseCronFeriasConfig: FC = () => {
  const { menuToggle } = useLayout()
  const {
    loadingFerias,
    dataFerias,
    pagination,
    actionsFerias,
    filters,
    fetching,
    query,
    tableInteractionFerias,
    companieId,
    setFilename,
    setQuery
  } = useParametrizationConfigPurchase()
  const { companies: authCompanies } = useAuth()

  const { hasSessions } = useSessions()
  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 225px)'
          : 'calc(100vh - 193px)'
        : hasSessions
        ? 'calc(100vh - 366px)'
        : 'calc(100vh - 334px)',
    [menuToggle, hasSessions]
  )

  return (
    <Box mW={400}>
      <LayoutTools
        title={'Cronograma Compra - Férias'}
        filters={filters}
        actions={actionsFerias}
        query={query}
        onSearchChange={setQuery}
        onTitleChange={setFilename}
        isDisabled={loadingFerias || fetching || dataFerias.length === 0}
      />
      <SelectedTableBarReabCronPurchaseFerias />

      {loadingFerias ? (
        <LayoutLoader
          title="Recuperando informações..."
          message="Aguarde enquanto buscamos os dados no banco de dados"
        />
      ) : authCompanies?.length === 0 ? (
        <LayoutEmpty
          type="chartEmpty"
          title="É necessário pelo menos 1 empresa cadastrada no perfil"
          message=""
        />
      ) : authCompanies?.length > 1 && companieId === '' ? (
        <LayoutEmpty
          type="chartEmpty"
          title="Selecione ao menos 1 empresa"
          message="Filtre sua busca em cima para obter informações"
        />
      ) : dataFerias.length === 0 ? (
        <LayoutEmpty
          title="Nada encontrado!"
          message="Filtre sua busca ao lado para obter informações"
        />
      ) : (
        <Box>
          <Box paddingLeft={2}>
            <GridQuantity data={dataFerias} />
          </Box>

          <TableGrid
            id="cron-purchase-user"
            entity="cron-purchase-user"
            headers={cronPurchaseFerias}
            query={query}
            data={dataFerias}
            itsSortable={true}
            loading={fetching}
            actions={tableInteractionFerias}
            height={tableHeight}
            pagination={pagination}
          />
        </Box>
      )}
    </Box>
  )
}

export default PurchaseCronFeriasConfig
